<div class="error-message">
  @if (error.code) {
    <span>{{ 'error.'+ error.code | translate }}</span>
  }
  @if (!error.code) {
    <span>{{ 'error.99.999' | translate }}</span>
  }
</div>